function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Select, message, InputNumber } from "antd";
import Common from "../includes/Common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AddConfiguration = function AddConfiguration(_ref) {
  var handler = _ref.handler;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    formError = _useState4[0],
    setFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    formSuccess = _useState6[0],
    setFormSuccess = _useState6[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleUserPriceChange = function handleUserPriceChange(v) {
    form.setFieldsValue({
      diesel_user_price: v
    });
  };
  var handlePurchasePriceChange = function handlePurchasePriceChange(v) {
    form.setFieldsValue({
      diesel_purchase_price: v
    });
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setFormError('');
    setFormSuccess('');
    var formData = new FormData();
    formData.append('petrol_user_price', values.petrol_user_price);
    formData.append('diesel_user_price', values.diesel_user_price);
    formData.append('petrol_purchase_price', values.petrol_purchase_price);
    formData.append('diesel_purchase_price', values.diesel_purchase_price);
    formData.append('default_selected', 0);
    formData.append('user_id', Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'addconfiguration', formData).then(function (response) {
      if (response.data.status == 200) {
        setFormSuccess('Opération réussie');
        handler();
      } else {
        setFormError(response.data.message);
      }
    })["catch"](function (error) {
      setFormError('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [formError.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: formError,
      showIcon: true
    }), formSuccess.length > 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: formSuccess,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Form.Item, {
        name: "petrol_user_price",
        label: "Prix Essence \xE0 la Pompe",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          onChange: handleUserPriceChange,
          addonAfter: "GNF",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "diesel_user_price",
        label: "Prix Gazoil \xE0 la Pompe",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "GNF",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "petrol_purchase_price",
        label: "Prix d'achat Essence",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          onChange: handlePurchasePriceChange,
          addonAfter: "GNF",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "diesel_purchase_price",
        label: "Prix d'achat Gazoil",
        rules: [{
          required: true,
          message: 'Ce champs est obligatoire'
        }],
        children: /*#__PURE__*/_jsx(InputNumber, {
          addonAfter: "GNF",
          style: {
            width: '200px'
          },
          formatter: function formatter(value) {
            return "".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
          }
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormLoading,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER"
          })
        })
      })]
    })]
  });
};
export default AddConfiguration;